module.exports = __webpack_public_path__ + "static/media/chm-bau32_2.2e38c0aa.gif";